import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';

const notificationAPI = createApi({
    reducerPath: "notificationAPI",
    baseQuery,
    endpoints: (builder) => ({
        getNotificationCount: builder.mutation({
            query: () => {
                let apiUrl = `admin/notification/count`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response
        }),
        getAllNotifications: builder.mutation({
            query: ({page, size}) => {
                return {
                    url: `admin/notification?page=${page}&limit=${size}`,
                    method: "GET"
                };
            },
            invalidatesTags: ["notifications"],
        }),
        markAllNotificationAsRead: builder.mutation({
            query: () => {
                return {
                    url: `admin/notificationread-all`,
                    method: "GET"
                };
            }
        }),
        markNotificationAsRead: builder.mutation({
            query: ({ id }) => {
                return {
                    url: `admin/notification/${id}`,
                    method: "GET"
                };
            }
        })
    })
});

export const { 
    useGetNotificationCountMutation,
    useGetAllNotificationsMutation,
    useMarkAllNotificationAsReadMutation,
    useMarkNotificationAsReadMutation
} = notificationAPI;

export default notificationAPI;